module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-800.d85691a1.woff2";